export default __webpack_public_path__ + "static/media/HennessySans1765_W.85fdffdf.woff2";